import { useGraphMutation, useToast } from "@dashboard/library";
import { useTranslation } from "react-i18next";
import { UpdateEvaluationMutationVariables } from "@/graphql/generated/graphql";
import { UpdateEvaluation } from "@/graphql/mutations/UpdateEvaluation";

type UseUpdateEvaluationProps = {
  onUpdateSuccess?: () => void;
};

export function useUpdateEvaluation({
  onUpdateSuccess,
}: UseUpdateEvaluationProps = {}) {
  const { t } = useTranslation();

  const { show } = useToast();

  const [mutation, { loading }] = useGraphMutation(UpdateEvaluation, {
    onCompleted(data) {
      if (data.updateEvaluation.__typename === "Evaluation") {
        show({
          message: t("evaluation_updated"),
          variant: "success",
        });

        onUpdateSuccess?.();
        return;
      }

      show({
        variant: "critical",
        message: data?.updateEvaluation.message,
      });
    },
    onError() {
      show({
        variant: "critical",
        message: t("error.generic.title"),
      });
    },
  });

  const updateEvaluation = async (input: UpdateEvaluationMutationVariables) => {
    mutation({
      variables: input,
    });
  };

  return {
    updateEvaluation,
    loadingUpdateEvaluation: loading,
  };
}
